import { render } from "./apnsadd.vue?vue&type=template&id=c40106a2&scoped=true"
import script from "./apnsadd.vue?vue&type=script&lang=js"
export * from "./apnsadd.vue?vue&type=script&lang=js"

import "./apnsadd.vue?vue&type=style&index=0&id=c40106a2&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c40106a2"]])

export default __exports__